module.exports = "/_next/static/images/5a859e6d31b2429694a14af1f7ccc1cc-open-graph-mgm.jpg";